<script setup>
import { Head, useForm } from "@inertiajs/vue3";

import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import IftaLabel from "primevue/iftalabel";
import InputText from "primevue/inputtext";
import Message from "primevue/message";
import Password from "primevue/password";

defineProps({
  canResetPassword: Boolean,
  status: String,
});

const form = useForm({
  email: "",
  password: "",
  remember: false,
});

const submit = () => {
  form
    .transform((data) => ({
      ...data,
      remember: form.remember ? "on" : "",
    }))
    .post(route("login"), {
      onFinish: () => form.reset("password"),
    });
};
</script>

<script>
import AuthLayout from "@/Layouts/AuthLayout.vue";

export default {
  layout: AuthLayout,
};
</script>

<template>
  <div class="login">
    <Head title="Log in" />

    <div v-if="status" class="status">
      {{ status }}
    </div>

    <form class="auth" @submit.prevent="submit">
      <div class="form-grid-1">
        <IftaLabel>
          <InputText
            id="email"
            v-model="form.email"
            type="email"
            placeholder="Email"
            autocomplete="username"
            required
            autofocus
            fluid
          />
          <label for="email">Email</label>
          <Message
            v-if="form.errors.email"
            severity="error"
            variant="simple"
            size="small"
          >
            {{ form.errors.email }}
          </Message>
        </IftaLabel>

        <IftaLabel>
          <Password
            id="password"
            v-model="form.password"
            placeholder="Password"
            :feedback="false"
            toggleMask
            required
            fluid
          />
          <label for="password">Password</label>
          <Message
            v-if="form.errors.password"
            severity="error"
            variant="simple"
            size="small"
          >
            {{ form.errors.password }}
          </Message>
        </IftaLabel>
      </div>

      <div class="remember-me-wrapper">
        <label for="remember">
          <Checkbox
            v-model="form.remember"
            name="remember"
            id="remember"
            binary
          />
          <span class="ff-text-subtile">Remember me</span>
        </label>
      </div>

      <div class="actions-wrapper">
        <Button
          v-if="canResetPassword"
          as="link"
          :href="route('password.request')"
          text
          severity="secondary"
          size="small"
        >
          Forgot your password?
        </Button>

        <Button
          type="submit"
          severity="contrast"
          :disabled="form.processing"
          :loading="form.processing"
          >Log in</Button
        >
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
form.auth {
  margin-top: 1rem;
}

.remember-me-wrapper {
  display: block;

  & > label {
    display: flex;
    align-items: center;

    & > span {
      margin-left: 0.5rem;
    }
  }
}
</style>
